import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WA_LINK } from "../../data/content";
import { WA } from "../../constants/testIds";

export default function WhatsAppFloat() {
  return (
    <motion.a
      href={WA_LINK}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={WA.float}
      initial={{ opacity: 0, y: 20, scale: 0.9 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ delay: 1.8, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ scale: 1.05 }}
      className="fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 h-12 md:h-14 px-4 md:px-5 rounded-full bg-[#25D366] text-white shadow-lg shadow-[#25D366]/30 hover:shadow-[#25D366]/50"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={20} />
      <span className="hidden sm:inline text-xs uppercase tracking-[0.2em] font-medium">
        WhatsApp
      </span>
    </motion.a>
  );
}
